import {createI18n} from 'vue-i18n'
import config from "@/config"

const i18n = createI18n({
	legacy: false,
	fallbackLocale: config.LANG,
	locale: config.LANG,
	globalInjection: true,
	messages: {}
})

export default i18n;
